export const calculateRoundedPercentage = (
  numerator: number,
  denominator: number
): number => {
  const percentage = (numerator / denominator) * 100;
  return Math.round(percentage * 100) / 100;
};

export const roundToTwoDecimals = (value: number): number => {
  return Number(value.toFixed(2));
};

export const roundToThreeDecimals = (num: number): number => {
  return Number(num.toFixed(3));
};

// Statistical helpers moved into this common helpers file
/**
 * Compute the mean from a running sum and count.
 * Returns 0 when `count` is 0 or negative to avoid Infinity/NaN
 * and to make downstream numeric comparisons safe.
 */
export const meanFromSum = (sum: number, count: number): number => {
  if (count <= 0) {
    return 0;
  }

  return sum / count;
};

export const varianceFromSums = (sumSq: number, sum: number, count: number) => {
  const mean = meanFromSum(sum, count);
  return sumSq / count - mean * mean;
};

export const stdDevFromVariance = (variance: number) => {
  return Math.sqrt(Math.max(0, variance));
};

export const stdDevFromSums = (sumSq: number, sum: number, count: number) => {
  const variance = varianceFromSums(sumSq, sum, count);
  return stdDevFromVariance(variance);
};

export const square = (x: number) => {
  return x * x;
};
